import { useMemo } from 'react';
import { getRuntimeBlockId } from '../utils/runTimeBlocks';

// used to get the corresponding id that will be used to refer the block in global state store
export function useGetBlockStateId({
  originalBlockId,
  runtimeBlockKey,
}: {
  originalBlockId: string;
  runtimeBlockKey?: string;
}) {
  const runtimeBlockId = useMemo(
    () =>
      runtimeBlockKey
        ? getRuntimeBlockId({
            originalBlockId,
            runtimeBlockKey,
          })
        : originalBlockId,
    [originalBlockId, runtimeBlockKey],
  );

  return {
    blockStateId: runtimeBlockId,
  };
}
